import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useInvertedLocalize } from '../../../utils/localization';

import {
  PRIMARY_CERTIFIER,
  REVIEW_AND_SUBMIT_COMMENT,
  REVIEW_AND_SUBMIT_COMPLETED,
  REVIEW_AND_SUBMIT_NOT_COMPLETED,
  REVIEW_AND_SUBMIT_SIGNATURE,
  REVIEW_AND_SUBMIT_STEP_1,
  REVIEW_AND_SUBMIT_STEP_2,
  SECONDARY_CERTIFIER,
  TAB_STATUS_TODO,
  TITLE,
} from './constant';
import { invertedMessages } from './messages';

import './ReviewAndSubmitHeader.css';

function ReviewAndSubmitHeader({ firstStep, setFirstStep }) {
  const l = useInvertedLocalize(invertedMessages);
  const {
    reviewAndSubmit,
    tabs: { tabData },
  } = useSelector((state) => state?.certifications?.details);

  const todoTabCount = tabData?.find(
    (tab) => tab.key === TAB_STATUS_TODO
  )?.count;
  const [config, setConfig] = useState();
  const hasZeroCountForItems = todoTabCount === 0;

  useEffect(() => {
    if (reviewAndSubmit) {
      setConfig({
        certifier: reviewAndSubmit.primaryCertifier
          ? PRIMARY_CERTIFIER
          : SECONDARY_CERTIFIER,
        isComplete: hasZeroCountForItems
          ? REVIEW_AND_SUBMIT_COMPLETED
          : REVIEW_AND_SUBMIT_NOT_COMPLETED,
        withESignature: reviewAndSubmit.withESignature
          ? REVIEW_AND_SUBMIT_SIGNATURE
          : REVIEW_AND_SUBMIT_COMMENT,
        step: firstStep ? REVIEW_AND_SUBMIT_STEP_1 : REVIEW_AND_SUBMIT_STEP_2,
      });
    }
  }, [todoTabCount, reviewAndSubmit, firstStep]);

  const reviewAndSubmitModalHeader = classnames('ReviewAndSubmitModal-header');

  const title = l(
    TITLE[config?.certifier]?.[config?.isComplete]?.[config?.withESignature]?.[
      config?.step
    ]
  );

  const goBack = () => {
    if (!reviewAndSubmit?.isSubmittingReviewAndSubmit) {
      setFirstStep(true);
    }
  };

  return (
    <div className={reviewAndSubmitModalHeader}>
      {/* TODO: Use ButtonIcon instead here */}
      <div
        className={
          firstStep
            ? 'ReviewAndSubmitModal-headerIcon--hidden'
            : 'ReviewAndSubmitModal-headerIcon--visible'
        }
        onClick={goBack}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            goBack();
          }
        }}
        role='button'
        tabIndex='0'>
        <Icon kind='ChevronLeft' color='neutral-1000' />
      </div>
      <div className='ReviewAndSubmitModal-headerTitle'>{title}</div>
    </div>
  );
}

ReviewAndSubmitHeader.propTypes = {
  firstStep: PropTypes.bool.isRequired,
  setFirstStep: PropTypes.func.isRequired,
};

export default ReviewAndSubmitHeader;
